/**
 * The peg registry ("repo") the portal talks to for pegs, keys, releases
 * and peg reviews.
 *
 * Production by default, so a build with nothing set behaves exactly as the
 * hard-coded URL did. NEXT_PUBLIC_REPO_URL points a build at another repo —
 * a local stack for development, or the e2e suite's fake. Next inlines it at
 * build time like every other NEXT_PUBLIC_* value.
 */
export const REPO_URL = (process.env.NEXT_PUBLIC_REPO_URL || 'https://repo.workpeg.com').replace(/\/+$/, '');

/** `repoUrl('/api/pegs/')` → `https://repo.workpeg.com/api/pegs/`. */
export const repoUrl = (path) => `${REPO_URL}${path}`;

/** A peg id as one URL path segment. Ids are DNS labels today; quote anyway. */
export const pegPath = (pegId) => encodeURIComponent(String(pegId));

/** A repo answer that wasn't 2xx: its status and parsed body (or null). */
export class RepoRequestError extends Error {
    constructor(status, data) {
        super(`repo request failed (${status})`);
        this.name = 'RepoRequestError';
        this.status = status;
        this.data = data;
    }
}

/** The JSON body of `response`, or null when there is none or it isn't JSON. */
export const readJson = async (response) => {
    try {
        const text = await response.text();
        return text ? JSON.parse(text) : null;
    } catch (error) {
        return null;
    }
};
